var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardComponent',{attrs:{"show-title":false}},[_c('LeadListComponent',{attrs:{"height":"500px","headers":_vm.headers,"leads":_vm.leads},on:{"accept":_vm.onAccept,"decline":_vm.onDecline,"click:row":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }